import { render } from "./Zixun.vue?vue&type=template&id=6c334118&scoped=true"
import script from "./Zixun.vue?vue&type=script&lang=js"
export * from "./Zixun.vue?vue&type=script&lang=js"

import "./Zixun.vue?vue&type=style&index=0&id=6c334118&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c334118"]])

export default __exports__